var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconMicrosoftColoured = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 2h9.5v9.5H2z",
  fill: "#f25022"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 2H22v9.5h-9.5z",
  fill: "#7fba00"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M2 12.5h9.5V22H2z",
  fill: "#00a4ef"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 12.5H22V22h-9.5z",
  fill: "#ffb900"
})));

export default SvgIconMicrosoftColoured;